<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Time Series Report Data Loading...
  </div>
  <div v-else class="mb-4">
    <div ref="report" class="pl-2 py-2">
      <TimeSeriesReportHeader :report="report" />

      <b-card no-body>
        <b-card-header>
          <span class="text-muted">
            <b>{{ sample_type.name }}</b>
          </span>
        </b-card-header>

        <b-card-body class="py-0">
          <TimeSeriesReportTable
            v-for="(subset, index) in report.subsets"
            :key="index"
            :subset="subset"
            :report="report"
            class="my-3"
          />
        </b-card-body>
      </b-card>

      <b-card no-body>
        <b-card-header>
          <span class="text-muted">
            <b>Weekly Trends</b>
          </span>
        </b-card-header>

        <b-card-body class="">
          <b-row>
            <b-col v-for="(item, index) in analysisList" :key="index">
              <div class="text-center font-weight-bold">{{ item.analysis }} ({{ item.value_unit_abbrev }})</div>
              <TimeSeriesReportChart v-if="chart_type === 'line'" :report="report" :analysis="item" />

              <TimeSeriesReportBarChart v-if="chart_type === 'bar'" :report="report" :analysis="item" />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import SampleTypeModel from "@/models/lab/SampleTypeModel"
import TimeSeriesReportHeader from "./TimeSeriesReportHeader"
import TimeSeriesReportTable from "./TimeSeriesReportTable.vue";
import TimeSeriesReportChart from "./TimeSeriesReportChart.vue";
import TimeSeriesReportBarChart from "./TimeSeriesReportBarChart.vue";

export default {
  name: "TimeSeriesReport",
  components: {
    TimeSeriesReportHeader,
    TimeSeriesReportTable,
    TimeSeriesReportChart,
    TimeSeriesReportBarChart
  },
  props: {
    report: {
      type: Object,
      default: () => {
        return {}
      },
    },
    chart_type: {
      type: String,
      default: 'bar'
    }
  },
  data () {
    return {
      loading: true,
      sample_type: null
    }
  },
  computed: {
    analysisList () {
      const elements = this.report.data.map(item => {
        return item.sample_results.map(result => {
          return {
            analysis: result.analysis,
            value_unit_abbrev: result.value_unit_abbrev,
            analyte: result.analyte,
            analyte_id: result.analyte_id
          }
        })
      }).flat()
      return _.uniqBy(elements, 'analysis')
    },
  },
  async created () {
    this.loading = true

    if (this.report && this.report.params) {
      this.sample_type = new SampleTypeModel({ id: this.report.params.sample_type_id })
      await this.sample_type.fetch()
    }

    this.loading = false
  },
}
</script>
